import gql from 'graphql-tag'

const money = gql`
  fragment money on Money {
    amount
    currency
    symbol
    precision
    thousandSeparator
    decimalSeparator
    symbolPlacement
    formattedAmount
  }
`

export default money
